import { resolvePlanPrice } from './planAnnualPricing';

/** Preços SaaS da seção Desenvolvimento Web — valores numéricos por moeda e ciclo. */

export const WEB_DEV_PLAN_PRICES = {
  essential: {
    monthly: { BRL: 297, EUR: 49, USD: 59 },
    annual: { BRL: 2970, EUR: 490, USD: 590 }
  },
  growth: {
    monthly: { BRL: 697, EUR: 119, USD: 149 },
    annual: { BRL: 6970, EUR: 1190, USD: 1490 }
  },
  enterprise: {
    monthly: { BRL: 1997, EUR: 299, USD: 349 },
    annual: { BRL: 19970, EUR: 2990, USD: 3490 },
    plus: true
  }
};

export const WEB_DEV_CURRENCIES = ['BRL', 'EUR', 'USD'];

/**
 * @param {string} language — LanguageContext (pt-BR, pt-PT, en, …)
 */
export function getDefaultWebDevCurrency(language) {
  if (language === 'pt-BR') return 'BRL';
  if (language === 'pt-PT') return 'EUR';
  return 'USD';
}

const formatterCache = new Map();

function getNumberFormatter(locale) {
  if (!formatterCache.has(locale)) {
    formatterCache.set(
      locale,
      new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    );
  }
  return formatterCache.get(locale);
}

/**
 * @param {number} amount
 * @param {'BRL'|'EUR'|'USD'} currency
 * @param {'monthly'|'annual'} cycle
 * @param {{ plus?: boolean, language?: string }} [opts]
 */
export function formatWebDevPlanPrice(amount, currency, cycle, opts = {}) {
  const { plus = false, language = 'pt-BR' } = opts;
  const suffix = plus ? '+' : '';
  const isEn = language === 'en' || (language && !String(language).startsWith('pt'));
  const periodMonthly = isEn ? '/mo' : '/mês';
  const periodAnnual = isEn ? '/yr' : '/ano';
  const period = cycle === 'monthly' ? periodMonthly : periodAnnual;

  const n = getNumberFormatter(
    currency === 'BRL' ? 'pt-BR' : currency === 'EUR' ? 'pt-PT' : 'en-US'
  ).format(amount);

  if (currency === 'BRL') return `R$ ${n}${period}${suffix}`;
  if (currency === 'EUR') return `${n} €${period}${suffix}`;
  return `US$ ${n}${period}${suffix}`;
}

export function getWebDevPlanPrice(planKey, currency, cycle, language) {
  return resolvePlanPrice({
    plan: WEB_DEV_PLAN_PRICES[planKey],
    currency,
    cycle,
    language,
    formatPrice: formatWebDevPlanPrice
  });
}
